import { useContext, useEffect } from "react";
import AiAssistantContext from "./AiAssistantContext";

/**
 * Generic hook for registering a page with the AI Assistant bubble.
 * Call this in any page component to make the AI bubble visible for that page.
 * On unmount the bubble is automatically hidden.
 *
 * @param pageName - Machine-readable page identifier sent to the API (e.g. "cockpit")
 * @param filterParams - The current filter params to be sent with the AI summary request
 */
const useAiAssistant = (pageName: string, filterParams: Record<string, any>) => {
  const ctx = useContext(AiAssistantContext);

  useEffect(() => {
    if (!ctx) return;
    ctx.setConfig({ pageName, filterParams, isVisible: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName, JSON.stringify(filterParams)]);

  useEffect(() => {
    return () => {
      if (ctx) {
        ctx.setConfig(null);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAiAssistant;
